import OneShotTreeBuilder from './tree_builder.js'

export const CST_NS = 'http://www.sri.com/effigy/grammar#'

export default class CSTTreeBuilder extends OneShotTreeBuilder {

    topClass = `${CST_NS}NL2CSTResult`

}